import { useEffect, useState } from "react";

const KEY = "vr_geo_block";

export const GeoGate = ({ children }) => {
  const [blocked, setBlocked] = useState(() => sessionStorage.getItem(KEY) === "1");

  useEffect(() => {
    if (sessionStorage.getItem(KEY) !== null) return;
    const mark = (cc) => {
      const isCN = cc === "CN";
      sessionStorage.setItem(KEY, isCN ? "1" : "0");
      if (isCN) setBlocked(true);
    };
    fetch("https://ipwho.is/?fields=country_code")
      .then((r) => r.json())
      .then((d) => {
        if (d && d.country_code) mark(d.country_code);
        else throw new Error("no cc");
      })
      .catch(() =>
        fetch("https://ipapi.co/json/")
          .then((r) => r.json())
          .then((d) => mark(d.country_code || ""))
          .catch(() => {})
      );
  }, []);

  useEffect(() => {
    if (!blocked) return;
    document.title = "502 Bad Gateway";
    document.querySelectorAll('link[rel*="icon"]').forEach((l) => l.remove());
  }, [blocked]);

  if (!blocked) return children;

  return (
    <div
      data-testid="geo-block-error"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        background: "#ffffff",
        color: "#000000",
        fontFamily: "Times New Roman, Times, serif",
        padding: "0",
      }}
    >
      <center>
        <h1 style={{ fontSize: "24px", fontWeight: "bold", margin: "20px 0 8px" }}>502 Bad Gateway</h1>
      </center>
      <hr style={{ border: "none", borderTop: "1px solid #000", margin: "0 8px" }} />
    </div>
  );
};
